import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import styled from 'styled-components';

const data = [
  { name: 'Jan', Expense: 4000, Income: 2400 },
  { name: 'Feb', Expense: 3000, Income: 1398 },
  { name: 'Mar', Expense: 2000, Income: 9800 },
  { name: 'Apr', Expense: 2780, Income: 3908 },
  { name: 'May', Expense: 1890, Income: 4800 },
  { name: 'Jun', Expense: 2390, Income: 3800 },
  { name: 'July', Expense: 3490, Income: 4300 },
  { name: 'Aug', Expense: 2000, Income: 9800 },
  { name: 'Sep', Expense: 2780, Income: 3908 },
  { name: 'Oct', Expense: 1890, Income: 4800 },
  { name: 'Nov', Expense: 2390, Income: 3800 },
  { name: 'Dec', Expense: 3490, Income: 4300 }
];

const Container = styled.div`
  width: 22rem;
  background-color: white;
  padding: 1rem;
  border: 1px solid #e5e7eb;
  border-radius: 0.25rem;
`;

const ChartTitle = styled.strong`
  color: #4b5563;
  font-weight: 500;
`;

const ChartContainer = styled.div`
  margin-top: 0.75rem;
  width: 100%;
  height: 300px;
`;

export default function TransactionChart() {
  return (
    <Container>
      <ChartTitle>Transactions</ChartTitle>
      <ChartContainer>
        <ResponsiveContainer>
          <BarChart
            data={data}
            margin={{ top: 20, right: 10, left: -10, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3 0 0" vertical={false} />
            <XAxis dataKey="name" />
            <YAxis />
            <Tooltip />
            <Legend />
            <Bar dataKey="Income" fill="#0ea5e9" />
            <Bar dataKey="Expense" fill="#ea580c" />
          </BarChart>
        </ResponsiveContainer>
      </ChartContainer>
    </Container>
  );
}
